export enum OptionState {
  INITIAL = "initial",
  SELECTED = "selected",
  NOT_SELECTED = "not-selected",
}
